export default __webpack_public_path__ + "static/media/g-xl-3.cffb8708.png";